import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * When scrolling on a page down a bit,
 * then visiting another page, that new page is also scrolled.
 *
 * To fix this, we scroll to the top whenenver a page change occurs.
 *
 * This component returns null so it can be mounted as react component
 *
 * @returns null
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export { ScrollToTop };
